import React from 'react';
import { Box, Divider } from '@mui/material';
import ProfileForm from 'app/form/ProfileForm';
import AddCustomerForm from 'app/form/AddCustomerForm';

const AddCustomer = () => {
	return (
		<div>
			<AddCustomerForm />
		</div>
	);
};

export default AddCustomer;
